import { render, staticRenderFns } from "./CapProfPage.vue?vue&type=template&id=3745ba5a&scoped=true"
import script from "./CapProfPage.js?vue&type=script&lang=js&external"
export * from "./CapProfPage.js?vue&type=script&lang=js&external"
import style0 from "./CapProfPage.vue?vue&type=style&index=0&id=3745ba5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3745ba5a",
  null
  
)

export default component.exports